import React from 'react';

import { AccessCardSkeleton } from './AccessCardSkeleton';
import { PROGRESS_CARD_WIDTH } from './constants';

export function ProgressCardSkeleton({ className }: { className?: string }) {
  return (
    <AccessCardSkeleton
      width={PROGRESS_CARD_WIDTH}
      showTagPlaceholder
      className={className}
    />
  );
}
